import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

import { StaticText } from '@project_app/config/static.text';
import { GtmService } from '@app/core/services/analytics/gtm.service';

@Component({
    selector: 'app-bottom-navigation',
    templateUrl: './bottom-navigation.component.html',
    styleUrls: ['./bottom-navigation.component.scss'],
    standalone: true
})
export class BottomNavigationComponent {
    step = '';
    staticText = StaticText;
    destroySubject$: Subject<void> = new Subject();

    constructor(
        private router: Router,
        private gtmService: GtmService
    ) {
        this.step = this.router.url;
    }

    ngOnDestroy() {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    }

    navigateTo(url: string) {
        // log data only for home page
        if (this.router.url === '/') {
            this.gtmService.logEventTracking('home_page', 'bottom_nav_click', url.slice(0));
        }

        this.router.navigateByUrl(url, {
            state: {
                referrer: 'BottomNav'
            }
        });
    }
}
